import { serverLogger } from '@thrivent-web/logging-utils';

export function parseIntOrUndefined(value: string = ''): number | undefined {
  const parsed = parseInt(value, 10);
  return isNaN(parsed) ? undefined : parsed;
}

export function parseBoolOrUndefined(
  value: string | undefined,
): boolean | undefined {
  if (value === undefined || !['true', 'false'].includes(value.toLowerCase())) {
    return undefined;
  }
  return value.toLowerCase() === 'true';
}

const environmentValues = ['local', 'dev', 'stage', 'prod'] as const;

export type RumEnvironment = (typeof environmentValues)[number];

export function parseEnv(
  value: string | undefined,
): RumEnvironment | undefined {
  const environment = value?.toLowerCase?.().trim?.() ?? '';
  if (([...environmentValues] as string[]).includes(environment)) {
    return environment as RumEnvironment;
  }
  serverLogger.warn('Invalid environment provided to RUM configuration', {
    env: value,
  });
  return undefined;
}
